import type { Deck } from '@/framework/types';
import { slides } from './slides';

const deck: Deck = {
  slug: 'context-streams',
  category: 'event-talks',
  title: 'From Data Pipelines to Context Streams: Building Infrastructure for the Agent Era',
  speaker: 'David Kjerrumgaard',
  description: 'A 30-minute talk on context engineering infrastructure for AI agents.',
  date: '2026-05-20',
  context: 'Current Summit · London 2026',
  visibility: 'public',
  slides,
};

export default deck;
